export class SharedFormValidation {
  private errors: { [key: string]: string };

  constructor() {
    this.errors = {};
  }

  public addError = (propertyPath: string, error?: string) => {
    // If an error message for the specified property, if applicable...
    if (error) {
      this.errors[propertyPath] = error;
    }
    // Otherwise, remove the custom validation error property if nothing has been passed
    // back to indicate the custom validation rule is now satisfied...
    else {
      delete this.errors[propertyPath];
    }
  };

  public getErrors = () => this.errors;
}
